import React from "react";
import { Badge } from "@mui/material";
import styled from "@emotion/styled";
interface BadgePageProps {
  children: any;
  color: any;
}
const BadgePage: React.FC<BadgePageProps> = ({
  children = "",
  color = "secondary"
}) => {
  console.log("🚀 ~ file: BadgePage.tsx:12 ~ children:", children,color)
  const CustomBadge = styled(Badge)`
    background-color: ${color};
    border-radius: 17px;
    color: #000;
    font-feature-settings: "clig" off, "liga" off;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    padding-top:5px;
    padding-bottom:5px;
    padding-left:12px;
    padding-right:12px;
  `;
  return (
    <div>
      <CustomBadge >{children}</CustomBadge>
    </div>
  );
};

export default BadgePage;
